import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import RawStockCodeTable from '../../components/rawStockCode/RawStockCodeTable';
import RawStockCodeForm from '../../components/rawStockCode/RawStockCodeForm';

const RawStockCodePage = () => {
  const [selectedRawStockCode, setSelectedRawStockCode] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (code) => {
    setSelectedRawStockCode(code);
  };

  const handleFormReset = () => {
    setSelectedRawStockCode(null);
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <RawStockCodeTable onEdit={handleEdit} refreshTrigger={refreshTrigger} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <RawStockCodeForm
          selectedRawStockCode={selectedRawStockCode}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default RawStockCodePage; 